import { useNavigate } from 'react-router-dom'

import BettingFlowSelectionTemplate from '@/components/templates/bettingFlowSelection/bettingFlowSelectionTemplate'

export default function BettingFlowSelectionPage() {
    const navigate = useNavigate()

    return <BettingFlowSelectionTemplate navigate={navigate} />
}
